import * as yup from "yup";

// Yup schema for field validations
const TravelerSchema = yup.object().shape({
  firstName: yup.string().required("Field is required"),
  lastName: yup.string().required("Field is required"),
  email: yup.string().required("Field is required"),
});

const phoneRegex = /^[0-9\- ]{8,15}$/;

export const RequestQuoteSchema = yup.object().shape({
  firstName: yup.string().required("Field is required"),
  lastName: yup.string().required("Field is required"),
  email: yup.string().email("Must be in the format of an email").required("Field is required"),
  phone: yup.string().matches(phoneRegex, 'Phone number is not valid').required("Field is required"),
  // phone: yup.string().required("Field is required"),
  groupName: yup.string().transform(value => (value.length == 0 ? undefined : value)),
  comments: yup.string(),
  // numGuests: yup.number().notRequired(),
  numGuests: yup.number().required("Required"),
  travelers: yup.array().of(TravelerSchema)
});

export type RequestQuoteFormData = yup.InferType<typeof RequestQuoteSchema>;

export const RequestQuoteSchemaDefaultValues: RequestQuoteFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  groupName: "",
  comments: "",
  numGuests: 2,
  travelers: []
};
